import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { contacts: () => import('./ContactsPage.vue') },
} satisfies FeatureRoutes
